'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@/utils');

exports.default = {
  methods: {
    pushPlay: function pushPlay(query) {
      var location = window.location.href.slice(0, window.location.href.indexOf('#'));
      var win = window.open(location + '#/play' + (0, _utils.stringifyQuery)(query), '课程播放', 'width=' + window.screen.width + ',height=' + window.screen.height + ',top=0,left=0,toolbar=no, menubar=no, scrollbars=yes, resizable=no,location=no, status=no');
      win.vm = this;
    },
    update: function update(userLearningFlowID, currentTime) {
      var _this = this;

      this.$ajax({
        url: 'api-course/portal/userLearningFlow',
        method: 'PUT',
        data: {
          userLearningFlowID: userLearningFlowID,
          playEndTime: currentTime ? parseInt(currentTime) : ''
        }
      }).then(function () {
        _this.$$forceRender && typeof _this.$$forceRender === 'function' && _this.$$forceRender();
      });
    }
  }
};